// Plain modules
import {Routes, RouterModule} from '@angular/router';

// Components used as view routes
import {
  HomeComponent
} from './components/views/index';
import {AboutComponent} from './components/views/about/about.component';
import {ConsultingComponent} from './components/views/consulting/consulting.component';
import {ContactComponent} from './components/views/contact/contact.component';
import {CareersComponent} from './components/views/careers/careers.component';

// Configure routes
const routes: Routes = [
  {path: 'home/:navState', component: HomeComponent},
  {path: 'about/:contentDetailId', component: AboutComponent},
  {path: 'about', component: AboutComponent},
  {path: 'consulting', component: ConsultingComponent},
  {path: 'contact', component: ContactComponent},
  {path: 'careers', component: CareersComponent},

  // Redirect for all other routes
  {path: '**', redirectTo: '/home/welcome'}
];

export const AppRoutes = RouterModule.forRoot(routes, {
  useHash: false
});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts